var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.data),function(item,index){return _c('filter-list-item',{key:index,attrs:{"checked":_vm.value.includes(item.value),"item":item},on:{"change":_vm.onChange}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }